import { faEye } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Popover, Space } from "antd"
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import { Token } from "../RichTextEditor/tokenModel"
import { EmailTemplate } from "./emailTemplateModel"

type Props = {
  template?: EmailTemplate
  tokens: Token[]
}

const EmailTemplatePreview = ({ template, tokens }: Props) => {
  if (!template) {
    return <Button type="link" icon={<FontAwesomeIcon icon={faEye} />} disabled />
  }

  return <Popover
      trigger="click"
      placement="topRight"
      title={template.name}
      content={<Space direction="vertical" style={{width: '600px'}}>
        <div><strong>Subject:</strong></div>
        <RichTextEditor value={template.emailSubject ?? ''} disabled removeToolbar tokens={tokens} />
        <div><strong>Body:</strong></div>
        <RichTextEditor value={template.emailBody ?? ''} disabled removeToolbar tokens={tokens} />
      </Space>}
    >
      <Button type="link" icon={<FontAwesomeIcon icon={faEye} />} aria-label="Preview template" />
    </Popover>
}

export default EmailTemplatePreview
